@if (!useSummaryView) {
    <div [class.hidden]="hidden" animate.enter="fade-in" class="flex flex-col w-full justify-between">
        <div class="flex flex-row items-center w-full">
            <mat-form-field class="w-full">
                <mat-label>{{ label }}</mat-label>
                <input matInput type="text" [formControl]="controlOriginal" [readonly]="readonly" [required]="required" [placeholder]="placeholder" (blur)="onBlur.emit()">
                
                @if (controlOriginal.hasError('pattern') && !readonly) {
                    <mat-error>
                        {{ 'errorInFormat' | transloco }}
                    </mat-error>
                } @else if (controlOriginal.hasError('required') && !readonly) {
                    <mat-error>
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                } @else if (hint) {
                    <mat-hint>{{ hint }}</mat-hint>
                }
            </mat-form-field>
        </div>
    </div>
} @else {
    {{ defaultValue }}
}